<template>
  <div class="units-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${unitId ? 'Editar' : 'Cadastrar'} Unidade`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'units.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <units-form @submit="onSubmit" :id="unitId" :errors="errors"></units-form>
    </app-card>
  </div>
</template>

<script>
import UnitsForm from '@/components/Forms/UnitsForm.vue';
import UnitService from '@/services/unit.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'units-form-page',
  mixins: [ToastMixin],
  components: {
    UnitsForm,
  },
  data: () => {
    return {
      unitId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.unitId && this.save(data);
      this.unitId && this.update(this.unitId, data);
    },
    save(data) {
      this.isSaving = true;

      UnitService.save(data)
        .then(() => {
          this.toastify('Unidade cadastrada com sucesso!');
          this.$router.push({ name: 'units.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Unidade.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      UnitService.update(id, data)
        .then(() => {
          this.toastify('Unidade atualizada com sucesso!');
          this.$router.push({ name: 'units.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Unidade.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.unitId = this.$route.params.id;
  },
};
</script>

<style lang="scss" scoped></style>
